import { Stack, Typography } from '@mui/material';
import { NoAssignmentsIllustration } from 'assets/illustrations';
import { useTranslation } from 'react-i18next';
import { IllustrationContainer } from './styled';
import { messages } from '../../messages';

export const NoSurveysAssigned = () => {
  const { t } = useTranslation();

  return (
    <Stack height="100%" justifyContent="space-between">
      <IllustrationContainer>
        <NoAssignmentsIllustration style={{ maxWidth: '100%' }} />
        <Stack gap="0.8rem" maxWidth="37.5rem">
          <Typography variant="h1" textAlign="center">
            {t(messages.noSurveysAssigned())}
          </Typography>
          <Typography variant="body1" textAlign="center">
            {t(messages.weWillEmailYouWhenSurveysBecomeAvailable())}
          </Typography>
        </Stack>
      </IllustrationContainer>
    </Stack>
  );
};
